import { withRouter } from 'react-router';
import React from 'react'
import { get } from 'lodash'
import hoistNonReactStatics from 'hoist-non-react-statics'

import { publicRuntimeConfig } from 'config';
const basePath = get(publicRuntimeConfig, 'basePath', '')

export const navigate = (url) => {
    console.log('navigate', `${basePath}${url}`);
    /*if(window){
        window.location.href = `${basePath}${url}`;
    }*/
}

const withNavigation = (WrappedComponent) => {
    class NavigationComponent extends React.PureComponent {

        navigate(url) {
            this.props.history.push(`${basePath}${url}`);
        }

        render () {
            return <WrappedComponent {...this.props} navigate={this.navigate.bind(this)} />
        }
    }

    return hoistNonReactStatics(withRouter(NavigationComponent), WrappedComponent)
}

export default withNavigation
